import React, { Component } from 'react';

/*Material ui template */
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';


import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';
import InputLabel from '@material-ui/core/InputLabel';
import Select from 'react-select';



import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';


function NumberFormatCustom(props) 
{
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      decimalScale={2}
      fixedDecimalScale={true}
      onValueChange={values => {
        onChange({
          target: {
            id:"price",
            value: values.value,
          },
        });
      }}
      thousandSeparator
    />
  );
}

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};



class OtherCostInfo extends Component {
  
  state = {
  };

  constructor(props)
  {
    super(props);
    //Bindings
    this.handleChangeSelection = this.handleChangeSelection.bind(this);
  }

  componentDidMount()
  {
     this.props.actions.fetchUnits()
    .then(res=>{
      if(res.data.units && res.data.units.length>0)
      {
        let units = res.data.units.map(unit=>{
          let w = {};
          w.unit = w.value =unit.unit;
          w.name = w.label= unit.name;
          return w;
        });
        this.setState({
          units: units, 
        });
      }
    });
  }

  getValueCatalog(opts, id) 
  {
    let realValue = {};
    if(opts)
    {
      realValue = opts.find(o => o.value === id);
    }
    return realValue;
  }


  handleChangeSelection(val)
  {
    this.props.handleChange({target:{value:val.value,id:'unit'}}) 
  }

  render() {
    let tipo_costo = "Other Cost ";
    return (
      <React.Fragment>
        <Typography variant="h6" gutterBottom>
          {tipo_costo} Information
        </Typography>
        <Grid container spacing={24}>
          <Grid item xs={12} sm={6}>
            <InputLabel htmlFor="catalog" style={{marginRight:'10px'}}>Unit</InputLabel>
              <Select
                required
                id="unit"
                name="unit"
                value={this.getValueCatalog(this.state.units,this.props.costinfo.unit)}
                onChange={this.handleChangeSelection}
                options={this.state.units}
                isDisabled={this.props.reviewActive}
                error={this.props.errores.unit}
                errorText={this.props.errores.unit}
                helperText={this.props.errores.unit}
                styles={{control: (provided,state) => (this.props.errores.unit ? {...provided,borderColor: 'red', } : provided)}}
              >
              </Select>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              id="quantity"
              name="quantity"
              label="Quantity"
              fullWidth
              autoComplete="quantity"
              value={this.props.costinfo.quantity}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.quantity}
              helperText={this.props.errores.quantity}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="price"
              label="Unit Rate"
              type="text"
              value={this.props.costinfo.price}
              InputProps={{
                inputComponent: NumberFormatCustom,
              }}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.price}
              helperText={this.props.errores.price}
            />
          </Grid>
        </Grid>
  </React.Fragment>
    );
  }
}


function mapStateToProps(state) {
  return {
    cost: state.cost,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OtherCostInfo);



// WEBPACK FOOTER //
// ./src/features/cost/OtherCostInfo.js